import React, {useEffect, useRef} from 'react';
import {Card, Col, Form, FormCheck, Image, Row, Nav} from 'react-bootstrap';
import SmartEntityModal from "../../components/SmartEntityModal";
import {useNavigate} from "react-router-dom";
import ApiService from "../../api/ApiService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRightArrowLeft, faClose, faGift} from "@fortawesome/free-solid-svg-icons";
import {toast} from "react-toastify";
import LocalDataService from "../../api/LocalDataService";
import NoSpaceModal from "../../components/NoSpaceModal";
import SVipModal from "../../components/SVipModal";
import MigrationModal from "../../components/MigrationModal";

// 智能体团队卡片数据
const teamCards = [
    {
        id: 1,
        image: 'https://placehold.co/200x200',
        title: '智能AI团队',
        subtitle: '1个工作流',
    }, {
        id: 2,
        image: 'https://placehold.co/200x200',
        title: '智能AI团队',
        subtitle: '2个工作流',
    }, {
        id: 3,
        image: 'https://placehold.co/200x200',
        title: '智能AI团队',
        subtitle: '1个工作流',
    }, {
        id: 4,
        image: 'https://placehold.co/200x200',
        title: '智能AI团队',
        subtitle: '3个工作流',
    }, {
        id: 5,
        image: 'https://placehold.co/200x200',
        title: '智能AI团队',
        subtitle: '1个工作流',
    }, {
        id: 6,
        image: 'https://placehold.co/200x200',
        title: '智能AI团队',
        subtitle: '1个工作流',
    },
    // 其他团队卡片数据...
];

export default function AgentList() {
    const navigate = useNavigate();
    // 获取当前屏幕宽度
    const [isMobile, setIsMobile] = React.useState(false);
    const [agentAddDlgShow, setAgentAddDlgShow] = React.useState(false);//添加智能体
    const [showNoSpaceModal, setShowNoSpaceModal] = React.useState(false);//没有扣子空间
    const [showSVipModal, setShowSVipModal] = React.useState(false);//开通SVIP
    const [showMigrationModal, setShowMigrationModal] = React.useState(false);//迁移智能体

    const [hasSpaces, setHasSpaces] = React.useState(false);
    const [spaceList, setSpaceList] = React.useState([]);
    const api = new ApiService();
    const [data, setData] = React.useState([]);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [hasMoreData, setHasMoreData] = React.useState(true); // 新增状态：是否有更多数据
    const [isFetching, setIsFetching] = React.useState(false); // 新增状态：是否正在获取数据

    const [isSelectStatus, setIsSelectStatus] = React.useState(false);
    const [selectedCards, setSelectedCards] = React.useState([]); // 新增状态：选中的卡片

    const videoRefs = useRef({}); // 使用对象存储每个视频的ref
    // 标签相关状态
    const [tagList, setTagList] = React.useState([]);
    const [activeTag, setActiveTag] = React.useState(0); // 0表示全部


    // 模拟数据请求函数
    const fetchMoreData = async () => {
        if (!hasMoreData || isFetching) return; // 如果没有更多数据或正在获取数据，直接返回

        setIsFetching(true); // 设置为正在获取数据

        const reponse = await api.getWorkflowList(20, currentPage);
        if (reponse.code === -4001) {
            toast.error('请先登录');
            return
        } else if (reponse.code !== 200) {
            toast.error(reponse.msg);
            return
        }
        const newData = reponse.data ? reponse.data : [];
        // 假设每次加载10条新数据
        // const newData = Array.from({length: 10}, (_, index) => ({
        //     "id": index,
        //     "allowCopy": false,
        //     "badge": "https://taskmp.styleart.cn/2025-07-08/psdByG6tVd.png",
        //     "cover": "https://p3-flow-imagex-sign.byteimg.com/ocean-cloud-tos/FileBizType.BIZ_BOT_ICON/3965273130677195_1750234498012544870_xuRDPTXXWX.jpg~tplv-a9rns2rl98-image-qvalue.jpeg?rk3s=bbd3e7ed&x-expires=1754550015&x-signature=ZqXlxQ3r60EPjdncx41RjrGhOBU%3D",
        //     "video": "https://ve-template-0920.oss-cn-shanghai.aliyuncs.com/uploads/1751510546293_gqh7j4oayi.mp4",
        //     "content": "内容",
        //     "title": "标题"+index,
        //     "vip": 0,
        //     "cozeUrl": "扣子地址",
        //     "instructions": "教程",
        //     "flows": null,
        //     "created": "string",
        //     "updated": "string"
        // }));
        if (newData.length < 20) {
            setHasMoreData(false);
        }
        setData(prevData => [...prevData, ...newData]);
        setCurrentPage(prevPage => prevPage + 1);
        setIsFetching(false); // 重置为未获取数据状态

    };

    // 使用 Intersection Observer 监听元素是否进入视口
    const observer = React.useRef();
    const lastElementRef = React.useCallback(node => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMoreData && !isFetching) { // 只有在还有更多数据且未获取数据时才触发加载
                fetchMoreData();
            }
        });
        if (node) observer.current.observe(node);
    }, [hasMoreData, isFetching, activeTag]);


    // function refreshData() {
    //     setCurrentPage(1);
    //     setHasMoreData(true);
    //     setData([])
    //     fetchMoreData();
    // }

    async function fetchSpaces() {
        const reponse = await api.getCozeSpaceList();
        if (reponse.data != null && reponse.data.length > 0) {
            setSpaceList(reponse.data);
            setHasSpaces(true);
        } else {
            setSpaceList([]);
            setHasSpaces(false);
        }
    }

    // 获取标签列表
    async function fetchTags() {
        try {
            const response = await api.getWorkflowTags();
            if (response.code === 200) {
                // 过滤掉id为-1的标签
                const filteredTags = response.data.filter(tag => tag.id !== -1);
                setTagList([ ...filteredTags]);
            }
        } catch (error) {
            console.error('获取标签失败:', error);
        }
    }

    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };
        fetchSpaces();
        fetchTags();
        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);

        // 添加事件监听器
        const handleUserLoginStatusChange = () => {
           fetchSpaces() ;
           refreshData();
        };
        window.addEventListener('userLoginStatusChanged', handleUserLoginStatusChange);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('userLoginStatusChanged', handleUserLoginStatusChange);
        };
    }, []);

    // 处理单个卡片的选择和取消选择
    const handleCardSelect = (card, isSelected) => {
        if (isSelected) {
            setSelectedCards([...selectedCards, card]);
        } else {
            setSelectedCards(selectedCards.filter(item => item.id !== card.id));
        }
    };

    // 切换标签时刷新数据
    const handleTagChange = (tagId) => {
        setActiveTag(tagId);
        refreshData(tagId);
    };
    
    // 刷新数据
    const refreshData = (tagId = activeTag) => {
        setCurrentPage(1);
        setHasMoreData(true);
        setData([]);
        
        // 简单延迟以确保状态更新后获取数据
        setTimeout(() => {
            fetchMoreDataWithTag(tagId);
        }, 0);
    };
    
    // 根据标签获取数据
    const fetchMoreDataWithTag = async (tagId) => {
        if (isFetching) return;
        
        setIsFetching(true);
        
        try {
            const response = await api.getWorkflowList(20, 1, tagId === 0 ? null : tagId);
            if (response.code === -4001) {
                toast.error('请先登录');
            } else if (response.code !== 200) {
                toast.error(response.msg);
            } else {
                const newData = response.data ? response.data : [];
                setData(newData);
                setHasMoreData(newData.length >= 20);
                setCurrentPage(2);
            }
        } catch (error) {
            console.error('获取数据失败:', error);
        } finally {
            setIsFetching(false);
        }
    };

    // 处理迁移逻辑
    const handleMigrate = () => {
        console.log('迁移选中的智能体:', selectedCards);
        if (selectedCards.length <= 0) {
            toast.warn('请选择要迁移的智能体！');
            return;
        }
        // 迁移逻辑在这里实现
        // 如果没有可用空间，显示无空间提示
        if (!hasSpaces) {
            setShowNoSpaceModal(true);
            return;
        }

        // 检查是否有需要SVIP的bot
        var hasSvipBot = selectedCards.some(function (bot) {
            return bot.level === 1;
        });
        // 获取用户信息，检查是否是SVIP
        var user = LocalDataService.load_user_data();
        var isSvipUser = user && user.vip.leave == 2; // 假设用户level大于等于1为SVIP用户

        // 如果有需要SVIP的bot且用户不是SVIP
        if (hasSvipBot && !isSvipUser) {
            setShowSVipModal(true);
            return;
        }
        // 已在组件加载时获取过空间列表，这里刷新一次确保数据最新
        fetchSpaces();
        // 正常流程 - 打开迁移模态框
        setShowMigrationModal(true);


    };

    return (
        <>
            {/* 内容区域 */}
            <Row> {/* 根据 isMobile 动态调整 margin-left */}
                {/* 提示信息 */}
                <Col xs={12} style={{display: "none"}}>
                    <Card bg="dark" text="white"
                          style={{color: '#7D7D7D', borderRadius: '8px', marginBottom: '16px', textAlign: 'left'}}>
                        <Card.Body>
                            <Card.Text>
                                <Image src={'/images/coze/coze_notice_tip.svg'}
                                       style={{width: '26px', height: '26px', marginRight: '8px'}}/>
                                <span style={{color: '#6CE3F2'}}>重要提示：</span> 每个智能体仅能迁移一次，请确认目标空间后再操作。钱以后无法撤销或重新迁移。
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                {/* 新功能介绍 */}
                <Col xs={12}>
                    <Card style={{
                        background: 'linear-gradient(90deg, #02C8E3 30%, #9E22E2 130%)',
                        border: 'none',
                        borderRadius: '8px',
                        paddingLeft: '32px',
                        paddingRight: '32px',
                        marginBottom: '16px'
                    }}>
                        <Card.Body style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                            <Image src={'/images/coze/coze_tip_icon.svg'}
                                   style={{width: '50px', height: '50px', marginRight: '8px'}}/>
                            <div>
                                <h5 style={{textAlign: 'left'}}>智能体运行</h5>
                                <Card.Text style={{color: '#000000', textAlign: 'left'}}>
                                    点击智能体打开详情，点击使用智能体即可立即体验!
                                </Card.Text>
                            </div>
                            <span style={{
                                color: '#FFFFFF',
                                fontSize: '14px',
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                background: 'linear-gradient( 180deg, #FF7675 0%, #FB7473 100%)',
                                boxShadow: '0px 3px 6px 1px rgba(246,106,106,0.16)',
                                padding: '0px 8px',
                                borderStartStartRadius: '8px',
                            }}>
                新功能
              </span>
                        </Card.Body>
                    </Card>
                </Col>

                {/* 搜索框和按钮 */}
                <Col xs={12} style={{
                    position: 'sticky',
                    display: 'none',
                    zIndex: '999',
                    top: '56px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '10px',
                    width: '100%', // 确保宽度是固定的或自适应的
                    background: '#0a0e17', // 防止内容透过
                    padding: '4px 10px' // 可选：添加一些垂直内边距来避免内容紧贴边缘

                }}>
                    <Form.Control type="search" placeholder="搜索智能体..."
                                  style={{borderRadius: '8px'}}/>
                    {
                        isSelectStatus ? (
                            <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                                <button style={{
                                    marginLeft: '10px',
                                    borderRadius: '50px',
                                    background: "transparent",
                                    border: '1px solid #02C8E3',
                                    color: "#02C8E3",
                                    fontSize: '14px',
                                    padding: isMobile ? '4px 12px' : '8px 22px',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }} onClick={() => {
                                    //进入选择智能体状态
                                    setIsSelectStatus(false)
                                    setSelectedCards([]);
                                }}
                                >
                                    <FontAwesomeIcon icon={faClose} color={'#02C8E3'} size={'1x'}
                                                     style={{marginRight: '4px'}}/>
                                    取消迁移
                                </button>
                                <button style={{
                                    marginLeft: '10px',
                                    borderRadius: '50px',
                                    background: "#02C8E3",
                                    border: 'none',
                                    color: "#1E2129",
                                    fontSize: '14px',
                                    padding: isMobile ? '4px 12px' : '8px 22px',
                                }} onClick={handleMigrate}>
                                    <FontAwesomeIcon icon={faArrowRightArrowLeft} color={'#1E2129'} size={'1x'}
                                                     style={{marginRight: '4px'}}/>
                                    开始迁移
                                </button>

                            </div>
                        ) : (
                            <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                                <button style={{
                                    marginLeft: '10px',
                                    borderRadius: '50px',
                                    background: "transparent",
                                    border: '1px solid #02C8E3',
                                    color: "#02C8E3",
                                    fontSize: '14px',
                                    padding: isMobile ? '4px 12px' : '8px 22px',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }} onClick={() => {
                                    //进入选择智能体状态
                                    setIsSelectStatus(true)
                                }}
                                >
                                    <img src={'/images/coze/coze_agent_move.svg'} width={'20px'} height={'20px'}
                                         style={{marginRight: '4px'}} alt={''}/>
                                    去迁移
                                </button>
                                <button style={{
                                    marginLeft: '10px',
                                    borderRadius: '50px',
                                    background: "#02C8E3",
                                    border: 'none',
                                    color: "#1E2129",
                                    fontSize: '14px',
                                    padding: isMobile ? '4px 12px' : '8px 22px',
                                }} onClick={() => setAgentAddDlgShow(true)}>
                                    <img src={'/images/coze/coze_agent_add.svg'} width={'20px'} height={'20px'}
                                         style={{marginRight: '4px'}} alt={''}/>
                                    上架智能体
                                </button>
                            </div>
                        )
                    }

                </Col>
                {/* 标签导航栏 */}
                <Col xs={12} className="mb-3">
                    <Nav variant="pills" activeKey={activeTag} onSelect={(key) => handleTagChange(Number(key))}>
                        {tagList.map((tag) => (
                            <Nav.Item key={tag.id}>
                                <Nav.Link
                                    eventKey={tag.id}
                                    style={{
                                        color: activeTag === tag.id ? '#000000' : '#fff',
                                        backgroundColor: activeTag === tag.id ? 'rgba(2, 200, 227, 0.1)' : 'transparent',
                                        border: '1px solid #444',
                                        marginRight: '5px',
                                        marginBottom: '5px'
                                    }}
                                >
                                    {tag.title}
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                </Col>
                {/* 卡片展示区 */}
                <Col xs={12}>
                    <Row>
                        {data.map((card, index) => (
                            <Col key={index} xs={12} md={6} lg={4} xxl={3}
                                 style={{marginTop: '10px', marginBottom: '10px'}}>
                                <div style={{
                                    position: 'relative',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <Card className={'w-100'} bg={'dark'} style={{borderRadius: '8px'}}
                                          onClick={() => navigate(`/AgentInfo/${card.id}`)}
                                          onMouseEnter={() => {
                                              if (videoRefs.current[card.id]) {
                                                  const video = videoRefs.current[card.id];
                                                  // 防止重复播放
                                                  if (video.paused) {
                                                      const playPromise = video.play();
                                                      if (playPromise !== undefined) {
                                                          playPromise.catch(error => {
                                                              console.error('播放失败:', error);
                                                          });
                                                      }
                                                  }
                                              }
                                          }}
                                          onMouseLeave={() => {
                                              if (videoRefs.current[card.id]) {
                                                  const video = videoRefs.current[card.id];
                                                  video.pause();
                                                  video.currentTime = 0;
                                              }
                                          }}>
                                        <div style={{
                                            position: 'relative',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            background: 'linear-gradient(90deg, #02C8E3 30%, #9E22E2 130%)'
                                        }}>
                                            {/*<Image src={card.cover} height={'200px'}/>*/}
                                            <video
                                                style={{
                                                    width: '100%',
                                                    height: '200px',
                                                    objectFit: 'contain',
                                                    borderRadius: '8px',
                                                }}
                                                src={card.video}
                                                preload="metadata"
                                                poster={card.cover}
                                                muted={true}
                                                ref={(el) => {
                                                    videoRefs.current = {
                                                        ...videoRefs.current,
                                                        [card.id]: el
                                                    };
                                                }}>
                                            </video>
                                            <span style={{
                                                backgroundColor: card.vip === 0 ? '#2BC4D9' : '#B556EA',
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                color: 'white',
                                                position: 'absolute',
                                                top: '5px',
                                                left: '5px',
                                                borderRadius: '80px',
                                                padding: '1px 6px',
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}>
                                            {card.vip === 0 ? (
                                                <>
                                                    <FontAwesomeIcon icon={faGift} size={'1x'}
                                                                     style={{marginRight: '4px'}}/>
                                                </>
                                            ) : (<>
                                                <img src={'/images/vip_icon.svg'} width={'34px'} height={'20px'}/>
                                            </>)}

                                                {card.vip === 1 ? 'VIP' : (card.vip === 0 ? '免费' : 'SVIP')}
                                        </span>
                                            {/*<span style={{*/}
                                            {/*    padding: '1px 5px',*/}
                                            {/*    fontSize: '16px',*/}
                                            {/*    fontWeight: 'bold',*/}
                                            {/*    color: 'white',*/}
                                            {/*    backgroundColor: '#FF5A5A',*/}
                                            {/*    position: 'absolute',*/}
                                            {/*    bottom: '5px',*/}
                                            {/*    right: '5px',*/}
                                            {/*    borderRadius: '4px'*/}
                                            {/*}}>新</span>*/}
                                            {card.badge && <Image src={card.badge} style={{
                                                width: 'auto',
                                                height: '30px',
                                                position: 'absolute',
                                                bottom: '5px',
                                                right: '5px'
                                            }}/>}
                                            <span className="w-100" style={{
                                                display: 'inline-block',
                                                textAlign: 'left',
                                                position: "absolute",
                                                bottom: "0px",
                                                padding: "5px",
                                                color: '#fff',
                                                fontSize: '16px',
                                                whiteSpace: "nowrap", /* 防止文本换行 */
                                                overflow: "hidden", /* 超出部分隐藏 */
                                                textOverflow: "ellipsis", /* 使用省略号表示被隐藏的文本 */
                                                background:"linear-gradient(0deg, #00000094, transparent)"
                                            }}>{card.title}</span>
                                            <span style={{
                                                display: 'none',
                                                color: '#fff',
                                                fontSize: '12px',
                                                backgroundColor: 'rgba(186,186,186,0.45)',
                                                padding: '2px 6px',
                                                borderRadius: '5px',
                                                position: 'absolute',
                                                top: '5px',
                                                right: '5px'
                                            }}>已迁移</span>
                                        </div>

                                        <Card.Body style={{display: 'flex', justifyContent: 'space-between'}}>
                                        <span style={{textAlign: 'left', alignContent: 'center', color: 'white'}}>
                                            <img src={'/images/logo.svg'} width={'32px'} height={'32px'} style={{
                                                marginRight: '16px',
                                                background: '#717171',
                                                borderRadius: '50%'
                                            }}/>
                                            沸推AI
                                        </span>
                                            <span style={{
                                                textAlign: 'center',
                                                alignContent: 'center',
                                                color: '#060606',
                                                fontSize: '12px',
                                                background: '#2BC4D9',
                                                borderRadius: '50px',
                                                padding: '4px 14px',
                                                display:"grid"
                                            }}>
                                            1个工作流
                                        </span>

                                        </Card.Body>
                                    </Card>
                                    {// 选择框
                                        isSelectStatus && (
                                            <div style={{
                                                position: 'absolute',
                                                zIndex: 888,
                                                width: '100%',
                                                height: '100%',
                                                background: 'rgba(43,196,217,0.1)',
                                                borderRadius: '8px',
                                                border: selectedCards.includes(card.id) ? '1px solid rgba(43,196,217,0.8)' : "none",
                                            }} onClick={(e) => {
                                                if (card.allowCopy === true) {
                                                    var selected = selectedCards.includes(card);
                                                    handleCardSelect(card, !selected)
                                                }
                                            }}>
                                                {card.allowCopy === true && <FormCheck
                                                    type="checkbox"
                                                    id={`checkbox-${card.id}`}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '10px',
                                                        right: '10px',
                                                        zIndex: 999,
                                                        color: 'white',
                                                    }}
                                                    checked={selectedCards.includes(card)}
                                                    onChange={(e) => handleCardSelect(card, e.target.checked)}
                                                />}
                                            </div>
                                        )
                                    }
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
                {/* 观察目标元素 */}
                {hasMoreData ? (
                    <div ref={lastElementRef}
                         style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>加载更多...</div>
                ) : (
                    <div style={{
                        textAlign: 'center',
                        marginTop: '20px',
                        color: 'white'
                    }}>{data.length > 0 ? '没有更多数据了' : '暂无数据'}</div>
                )}
            </Row>
            <SmartEntityModal visible={agentAddDlgShow} onClose={() => setAgentAddDlgShow(false)}/>
            <NoSpaceModal visible={showNoSpaceModal} onClose={() => setShowNoSpaceModal(false)}/>
            <SVipModal visible={showSVipModal} onClose={() => setShowSVipModal(false)}/>
            <MigrationModal visible={showMigrationModal} selectedBotList={selectedCards} spaceList={spaceList}
                            onClose={() => setShowMigrationModal(false)}/>
        </>
    );
}